import React from 'react';
import { formatDateEs } from './recapUtils';

interface TeamSummary {
  name: string;
  color?: string | null;
  goals?: number | null;
}

interface RecapHeaderProps {
  location: string;
  date: string; // 'YYYY-MM-DD'
  team1: TeamSummary;
  team2: TeamSummary;
}

export default function RecapHeader({ location, date, team1, team2 }: RecapHeaderProps) {
  return (
    <header style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '24px 16px' }}>
      <p style={{ margin: 0, fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>{location}</p>
      <p style={{ margin: 0, fontSize: 14, color: 'rgba(255,255,255,0.5)' }}>{formatDateEs(date)}</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginTop: 12 }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 14, color: team1.color || '#FFFFFF', marginBottom: 4 }}>{team1.name}</div>
          <div style={{ fontSize: 48, fontWeight: 800, color: team1.color || '#FFFFFF' }}>{team1.goals ?? 0}</div>
        </div>
        <div style={{ fontSize: 32, color: 'rgba(255,255,255,0.4)' }}>—</div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 14, color: team2.color || '#FFFFFF', marginBottom: 4 }}>{team2.name}</div>
          <div style={{ fontSize: 48, fontWeight: 800, color: team2.color || '#FFFFFF' }}>{team2.goals ?? 0}</div>
        </div>
      </div>
    </header>
  );
}
